const onboardingData = () => {
    return {
        localizations: null,
        isPromoteAppEnabled: null,
        setLocalizations(localizations) {
            this.localization = localizations;
        },
        setIsPromoteAppEnabled(isPromoteAppEnabled) {
            this.isPromoteAppEnabled = isPromoteAppEnabled;
        },

        getReaderSteps() {
            const steps = [
                {
                    title: this.localization.reader.welcome.title,
                    subTitle: this.localization.reader.welcome.subTitle,
                    image: 'onboarding-1.svg',
                    paragraph: this.localization.reader.welcome.paragraph,
                    extraParagraph: this.localization.reader.welcome.extraParagraph,
                    step_name: 'welcome',
                    sliders: [],
                },
                {
                    title: this.localization.reader.highlights.title,
                    image: 'onboarding-2.svg',
                    paragraph: this.localization.reader.highlights.paragraph,
                    extraParagraph: this.localization.reader.highlights.extraParagraph,
                    step_name: 'highlights',
                    sliders: [],
                },
                {
                    title: this.localization.reader.resumes.title,
                    image: 'onboarding-3.svg',
                    paragraph: this.localization.reader.resumes.paragraph,
                    extraParagraph: this.localization.reader.resumes.extraParagraph,
                    step_name: 'resume',
                    sliders: [],
                },
            ];
            // We only add the app-promote step if it is NOT App.
            if (this.isPromoteAppEnabled) {
                steps.push({
                    title: this.localization.reader.appPromote.title,
                    image: 'onboarding-4.svg',
                    paragraph: this.localization.reader.appPromote.paragraph,
                    extraParagraph: this.localization.reader.appPromote.extraParagraph,
                    step_name: 'app-promote',
                    sliders: [],
                });
            }

            return steps;
        },
        getAudiobookSteps() {
            return [
                {
                    title: this.localization.audiobook.welcome.title,
                    subTitle: this.localization.audiobook.welcome.subTitle,
                    image: 'onboarding-welcome@2x.png',
                    paragraph: this.localization.audiobook.welcome.paragraph,
                    step_name: 'welcome',
                    sliders: [],
                },
                {
                    title: this.localization.audiobook.reproduction.title,
                    image: 'onboarding-reproduction@2x.png',
                    paragraph: this.localization.audiobook.reproduction.paragraph,
                    step_name: 'reproduction',
                    sliders: [],
                },
                {
                    title: this.localization.audiobook.narratorSpeed.title,
                    image: 'onboarding-speed@2x.png',
                    paragraph: this.localization.audiobook.narratorSpeed.paragraph,
                    step_name: 'narrator-speed',
                    sliders: [],
                },
                {
                    title: this.localization.audiobook.chapters.title,
                    image: 'onboarding-chapters@2x.png',
                    paragraph: this.localization.audiobook.chapters.paragraph,
                    step_name: 'chapters',
                    sliders: [],
                },
            ];
        },
    };
};

export default onboardingData;
